"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrySystem = void 0;
var events_1 = require("events");
var RetrySystem = /** @class */ (function () {
    function RetrySystem(delayMs) {
        this.delayMs = delayMs;
        this.event = new events_1.EventEmitter();
        if (this.delayMs < 0)
            this.updateTime(0);
    }
    Object.defineProperty(RetrySystem.prototype, "delay", {
        get: function () {
            return this.delayMs;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * handle when some event occurred. All possible event listed below
     *
     * 1. `before-run` - execute immediately when call try()
     * 2. `after-run`  - execute if and only if try callback is success
     * 3. `retry`      - execute everytime object has retry to execute callback
     *                 - parameter is object {countdown: number, error: Error}
     * 4. `error`      - execute when try() reject the result and finish retry but still not success
     *                 - parameter is Error
     *
     * @param type event type
     * @param cb callback when event occurred
     */
    RetrySystem.prototype.on = function (type, cb) {
        this.event.on(type, cb);
    };
    /**
     * apply new delay time to current object
     *
     * @param ms input delay time in millisecond
     */
    RetrySystem.prototype.updateTime = function (ms) {
        this.delayMs = ms;
        if (this.delayMs < 0)
            this.updateTime(0);
    };
    RetrySystem.prototype.try = function (cb, limit) {
        if (limit === void 0) { limit = 3; }
        return __awaiter(this, void 0, void 0, function () {
            var r, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 7]);
                        this.event.emit("before-run");
                        return [4 /*yield*/, cb()];
                    case 1:
                        r = _a.sent();
                        this.event.emit("after-run");
                        return [2 /*return*/, r];
                    case 2:
                        e_1 = _a.sent();
                        if (!(limit > 1)) return [3 /*break*/, 5];
                        if (!(this.delay > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, _this.delay); })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.event.emit("retry", { countdown: limit, error: new Error(e_1) });
                        return [2 /*return*/, this.try(cb, limit - 1)];
                    case 5:
                        this.event.emit("error", new Error(e_1));
                        return [2 /*return*/, Promise.reject(new Error(e_1))];
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return RetrySystem;
}());
exports.RetrySystem = RetrySystem;
//# sourceMappingURL=RetrySystem.js.map